/* tslint:disable */
/* eslint-disable */
/**
 * GateHouse AIS REST interface
 * AIS system for monitoring vessel traffic. Commercial WebService. Contact GateHouse support for more information.
 *
 * The version of the OpenAPI document: 0.2.2
 * Contact: support@gatehouse.dk
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { Geometry } from './Geometry';
import {
    GeometryFromJSON,
    GeometryFromJSONTyped,
    GeometryToJSON,
} from './Geometry';
import type { Location } from './Location';
import {
    LocationFromJSON,
    LocationFromJSONTyped,
    LocationToJSON,
} from './Location';
import type { Port } from './Port';
import {
    PortFromJSON,
    PortFromJSONTyped,
    PortToJSON,
} from './Port';
import type { Ship } from './Ship';
import {
    ShipFromJSON,
    ShipFromJSONTyped,
    ShipToJSON,
} from './Ship';

/**
 * 
 * @export
 * @interface Destination
 */
export interface Destination {
    /**
     * 
     * @type {Port}
     * @memberof Destination
     */
    port?: Port;
    /**
     * 
     * @type {Ship}
     * @memberof Destination
     */
    ship?: Ship;
    /**
     * 
     * @type {Geometry}
     * @memberof Destination
     */
    position?: Geometry;
    /**
     * 
     * @type {Location}
     * @memberof Destination
     */
    location?: Location;
    /**
     * For input: Expected Time of Arrival as indicated in eg. ERP system. Can be used for reference. For output: Expected Time of Arrival as calculated.
     * @type {string}
     * @memberof Destination
     */
    eta?: string;
}

/**
 * Check if a given object implements the Destination interface.
 */
export function instanceOfDestination(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function DestinationFromJSON(json: any): Destination {
    return DestinationFromJSONTyped(json, false);
}

export function DestinationFromJSONTyped(json: any, ignoreDiscriminator: boolean): Destination {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'port': !exists(json, 'port') ? undefined : PortFromJSON(json['port']),
        'ship': !exists(json, 'ship') ? undefined : ShipFromJSON(json['ship']),
        'position': !exists(json, 'position') ? undefined : GeometryFromJSON(json['position']),
        'location': !exists(json, 'location') ? undefined : LocationFromJSON(json['location']),
        'eta': !exists(json, 'eta') ? undefined : json['eta'],
    };
}

export function DestinationToJSON(value?: Destination | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'port': PortToJSON(value.port),
        'ship': ShipToJSON(value.ship),
        'position': GeometryToJSON(value.position),
        'location': LocationToJSON(value.location),
        'eta': value.eta,
    };
}

